import React from 'react';
import { useInfiniteScroll } from 'react-infinite-scroll-hook';

function InfiniteScrollWrapper({ hasNextPage, loading, loadMore, children }) {
  const infiniteContainerRef = useInfiniteScroll({
    hasNextPage,
    loading,
    onLoadMore: loadMore,
  });

  return (
    <div ref={infiniteContainerRef}>
      {children}
      {loading && <p style={{ textAlign: 'center', margin: 50 }}> Loading... </p>}
    </div>
  );
}

export default InfiniteScrollWrapper;
